import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import {
    BaseUserService,
    waitUntil,
    Mission,
} from "@smarterplan/ngx-smarterplan-core";

@Component({
    selector: "app-museum-auth-waiting",
    templateUrl: "./museum-auth-waiting.component.html",
    styleUrls: ["./museum-auth-waiting.component.scss"],
})
export class MuseumAuthWaitingComponent implements OnInit {
    missions: Mission[];

    selectedMission: Mission = null;

    @Output() onChooseMission = new EventEmitter<string>();

    constructor(private router: Router, private userService: BaseUserService) { }

    ngOnInit(): void {
        this.setCurrentMissions();
    }

    async setCurrentMissions() {
        await waitUntil(
            () =>
                this.userService.currentMissions !== undefined &&
                this.userService.currentMissions !== null,
        );
        this.missions = this.userService.currentMissions;
    }

    onGoToVisit() {
        if (this.selectedMission) {
            if (this.selectedMission.templateMissionID) {
                this.onChooseMission.emit(
                    this.selectedMission.templateMissionID,
                );
            } else {
                this.router.navigate(["museum", this.selectedMission.spaceID]);
            }
        }
    }
}
